// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GJMF","placeholdersHeader":"styles_placeholdersHeader__3Y7ZV","editorStyle":"styles_editorStyle__3Q3sj","placeholdersBox":"styles_placeholdersBox__3GVh_"};